









































	import Vue from 'vue';
    import ProfileNameComp from "../components/profile/ProfileNameComp.vue";
    import BuildsComp from "../components/profile/BuildsComp.vue";
    import ProfilePictureComp from "../components/profile/ProfilePictureComp.vue";
    import _users from '../services/endpoints/users';

    import ProgressShareComp from "../components/profile/ProgressShareComp.vue";
    import ProgressOverviewComp from "../components/profile/ProgressOverviewComp.vue";
	import SecondaryAccountsComp from "@/components/profile/SecondaryAccountsComp.vue";

    export default Vue.extend({
        name: "UserProfilePage",
        components: {ProgressOverviewComp, ProgressShareComp, ProfilePictureComp, BuildsComp, ProfileNameComp, SecondaryAccountsComp},
        data: () => ({
            foreignUser: null as any,
            hasNoApi: false,
            hasShared: false
        }),
        computed: {
            visitedID: function (): string {
                return this.$route.params.id;
            },
            visitedUser: function(): any {
				return this.visitedID ? this.foreignUser : this.$vStore.getters.loggedInUser;
            },
            ownProfile: function (): boolean {
                if (this.visitedUser) {
                    return this.visitedUser.id === this.$vStore.getters.loggedInUser.id;
                }
                return false;
            },
            profilePictureSize: function(): number {
                const width = this.$vStore.getters.windowWidth;
                if (width > 1510) {
                    return 128;
                } else if (width > 1263) {
                    return 112;
                } else {
                    return 96;
                }
            },
            showProgress: function(): boolean {
                return this.ownProfile || this.hasShared;
            }
        },
        created: async function (): Promise<void> {
            this.foreignUser = this.visitedID ? await _users.getWithID(this.visitedID) : null;
            this.hasNoApi = !(await _users.hasApi());
            this.hasShared = await _users.hasProgressShared(this.visitedID);
        }
    })
